import { render, staticRenderFns } from "./RoleSelectorPills.vue?vue&type=template&id=3126eabf&scoped=true&"
import script from "./RoleSelectorPills.vue?vue&type=script&lang=ts&"
export * from "./RoleSelectorPills.vue?vue&type=script&lang=ts&"
import style0 from "./RoleSelectorPills.vue?vue&type=style&index=0&id=3126eabf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3126eabf",
  null
  
)

export default component.exports